function normalizedPath(input) {
    const withoutQuery = input.split(/[?#]/u, 1)[0] || "/";
    const withLeadingSlash = withoutQuery.startsWith("/")
        ? withoutQuery
        : `/${withoutQuery}`;
    const collapsed = withLeadingSlash.replace(/\/+/gu, "/");
    return collapsed.length > 1 ? collapsed.replace(/\/+$/u, "") : collapsed;
}
function decodedSegment(segment) {
    try {
        return decodeURIComponent(segment);
    }
    catch {
        return null;
    }
}
export function parseLabRoute(input) {
    const path = normalizedPath(input);
    if (path === "/" || path === "/overview") {
        return { kind: "overview" };
    }
    if (path === "/home") {
        return { kind: "home" };
    }
    if (path === "/units") {
        return { kind: "units" };
    }
    if (path === "/sources") {
        return { kind: "sources" };
    }
    if (path === "/storyengine") {
        return { kind: "story-engine" };
    }
    if (path === "/editorial-management") {
        return { kind: "editorial-management" };
    }
    if (path === "/internal/feed-items") {
        return { kind: "internal-feed-items" };
    }
    const exactExampleMatch = /^\/internal\/feed-items\/([^/]+)\/([^/]+)$/u.exec(path);
    if (exactExampleMatch) {
        const itemKind = decodedSegment(exactExampleMatch[1]);
        const exampleId = decodedSegment(exactExampleMatch[2]);
        return itemKind && exampleId
            ? { kind: "internal-feed-example", itemKind, exampleId }
            : { kind: "not-found", path };
    }
    const unitMatch = /^\/internal\/feed-items\/([^/]+)$/u.exec(path);
    if (unitMatch) {
        const unitCode = decodedSegment(unitMatch[1]);
        return unitCode
            ? { kind: "internal-feed-item", unitCode }
            : { kind: "not-found", path };
    }
    return { kind: "not-found", path };
}
export function labRoutePath(route) {
    switch (route.kind) {
        case "overview":
            return "/";
        case "home":
            return "/home/";
        case "units":
            return "/units/";
        case "sources":
            return "/sources/";
        case "story-engine":
            return "/storyengine/";
        case "editorial-management":
            return "/editorial-management/";
        case "internal-feed-items":
            return "/internal/feed-items/";
        case "internal-feed-item":
            return `/internal/feed-items/${encodeURIComponent(route.unitCode)}/`;
        case "internal-feed-example":
            return `/internal/feed-items/${encodeURIComponent(route.itemKind)}/${encodeURIComponent(route.exampleId)}/`;
    }
}
